<template>
    <div class="layout" @scroll="scroll" @click="click">
        <app-modal :avatar="avatar"></app-modal>

        <div class="logo-wrapper">
            <img
                :src="currentLogoUrl"
                :class="providerImageClasses"
                class="logo"
                alt="wifeed logo"
            />

            <div class="hr"></div>
        </div>

        <app-sidebar v-if="$route.path !== '/login'"></app-sidebar>

        <router-view name="header"></router-view>

        <div class="user-system" name="config">
            <LocaleChanger />
            <img v-if="avatar" :src="avatar" @click="openInfoUser" />
            <i v-else class="mdi mdi-account pointer" @click="openInfoUser"></i>
        </div>

        <router-view></router-view>
    </div>
</template>

<script>
import AppModal from "./infouser-modal/InfoUserModal";
import AppSidebar from "@components/generic/sidebar/Sidebar";
import EventBus from "@packages/event-bus";
import LocaleChanger from "@views/layout/locale-changer/LocaleChanger";
import provider from "@mixins/provider";

const NEW_LOGO = "/images/logo.svg";
const NEW_PARTNER_LOGO = "/images/logo/logo-partner.svg";

export default {
    components: {
        LocaleChanger,
        AppSidebar,
        AppModal,
    },

    data() {
        return {
            avatar: null,
        };
    },

    computed: {
        isPartner() {
            return (
                this.$store.state.users.user &&
                this.$store.state.users.user.tipo === "PARCEIRO"
            );
        },
        defaultLogoUrl() {
            return this.isPartner
                ? NEW_PARTNER_LOGO
                : NEW_LOGO;
        },
        currentLogoUrl() {
            if (this.whitelabelLogoUrl) return this.whitelabelLogoUrl;

            return this.savedProvider
                ? {
                      ["wcs"]:
                          "https://wifeed-public.s3.sa-east-1.amazonaws.com/Logo_Intelligence_WCS.png",
                      ["haggi"]:
                          "https://wifeed-public.s3.sa-east-1.amazonaws.com/Logo_Haggi_NTCORP.png",
                      ["ntcorp"]:
                          "https://wifeed-public.s3.sa-east-1.amazonaws.com/Logo_NTCORP.png",
                      ["tely"]:
                          "https://wifeed-public.s3.sa-east-1.amazonaws.com/Logo_Tely.png",
                      ["data-carrier"]:
                          "https://wifeed-public.s3.sa-east-1.amazonaws.com/Logo_Data_Carrier.jpg",
                      ["vivo"]:
                          "https://wifeed-public.s3.sa-east-1.amazonaws.com/Logo_Vivo.png",
                      ["vero"]: "/images/logo/vero.png",
                      ["unifique"]: "/images/logo/unifique.png",
                      ["abc"]: "/images/logo/abc.png",
                      ["wifeed"]: NEW_LOGO,
                      ["master"]: "/images/logo/master.webp",
                  }[this.savedProvider]
                : this.defaultLogoUrl;
        },
        providerImageClasses() {
            if (this.whitelabelLogoUrl) return { "logo-whitelabel": true };

            return {
                "logo-external": this.isCustomProvideLogin,
                "logo-wcs": this.savedProvider === "wcs",
                "logo-haggi": this.savedProvider === "haggi",
                "logo-ntcorp": this.savedProvider === "ntcorp",
                "logo-wifeed": [NEW_LOGO, NEW_PARTNER_LOGO].includes(
                    this.currentLogoUrl
                ),
                "logo-tely": this.savedProvider === "tely",
                "logo-data-carrier": this.savedProvider === "data-carrier",
                "logo-vivo": this.savedProvider === "vivo",
                "logo-vero": this.savedProvider === "vero",
                "logo-unifique": this.savedProvider === "unifique",
                "logo-abc": this.savedProvider === "abc",
                "logo-master": this.savedProvider === "master",
            };
        },
    },

    methods: {
        scroll() {
            EventBus.$emit("SCROLL");
        },

        click(evt) {
            EventBus.$emit("CLICK", evt);
        },
        openInfoUser() {
            EventBus.$emit("VIEW-USER-INFO");
        },
        changeAvatarHandler(avatar) {
            this.avatar = avatar;
        },
        changeLogoHandler(logo) {
            this.logo = logo;
        },
        setAvatar() {
            let user =
                this.$store.state.users.user || this.$store.state.users.admin;
            const loginAs = this.$store.state.users.loginAs;
            this.avatar =
                loginAs === true || loginAs === "true"
                    ? sessionStorage.getItem("avatar-loginAs")
                    : sessionStorage.getItem("avatar");
            this.logo = user.logo;
        },
    },

    mounted() {
        this.setAvatar();

        this.setWhitelabelClassOnBody();

        EventBus.$on("CHANGE-AVATAR", this.changeAvatarHandler);
        EventBus.$on("CHANGE-LOGO", this.changeLogoHandler);
        EventBus.$on("SET-AVATAR", this.setAvatar);
    },

    beforeDestroy() {
        EventBus.$off("CHANGE-AVATAR", this.changeAvatarHandler);
        EventBus.$off("CHANGE-LOGO", this.changeLogoHandler);
        EventBus.$off("SET-AVATAR", this.setAvatar);
    },

    mixins: [provider],
};
</script>

<style lang="scss">
@import "~@variables";

.layout {
    display: grid !important;
    grid-template-rows: calc(13vh - 15px) calc(87vh - 15px);
    grid-template-columns: 240px auto 10%;
    grid-template-areas:
        "logo header config"
        "sidebar main main";
    grid-gap: 30px;

    @media (max-width: $desktop-md-max) {
        grid-template-rows: calc(15vh) calc(85vh - 14px);
        grid-gap: 14px;
    }

    height: 100vh;
    width: 100vw;
    background-color: $white;
    flex-wrap: wrap;
    overflow-y: auto;
    overflow-x: hidden;

    .logo-wrapper {
        grid-area: logo;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        position: sticky;
        top: 0;
        z-index: 2;
        background-color: inherit;

        .logo {
            width: 85px;

            &.logo-whitelabel {
                width: auto;
                height: auto;
                max-width: 160px;
                max-height: 56px;
                object-fit: contain;
            }

            &.logo-wifeed {
                width: auto;
                height: auto;
                max-width: 176px;
                max-height: 80px;
            }

            &.logo-external {
                width: 150px;
            }

            &.logo-haggi {
                width: 150px;
            }

            &.logo-ntcorp {
                width: 150px;
            }

            &.logo-wcs {
                width: 150px;
            }

            &.logo-tely {
                width: 95px;
            }

            &.logo-data-carrier {
                background-color: #365176;
                padding: 10px;
                border-radius: 5px;
                width: 120px;
            }

            &.logo-vivo {
                width: 180px;
            }

            &.logo-abc {
                width: 142px;
                padding: 10px 0 16px 0;
            }

            &.logo-unifique {
                width: 155px;
            }

            &.logo-vero {
                width: 140px;
            }

            &.logo-master {
                width: 140px;
            }
        }

        &:after {
            position: absolute;
            bottom: 0;
            content: "";
            width: 60%;
            border-bottom: 1px solid rgba($grey-4, 0.27);
        }
    }

    header {
        grid-area: header;
        max-width: 100% !important;
        margin-right: 50px;
    }

    aside {
        grid-area: sidebar;
        flex-shrink: 0;
    }

    main {
        padding-right: 50px;
        grid-area: main;
        overflow: auto;

        &.smaller-padding {
            padding-right: 20px;
        }
    }

    .user-system {
        width: 130px;
        padding: 5px;
        grid-area: config;
        display: flex;
        gap: 20px;
        align-items: center;

        i {
            font-size: 62px;
            color: #a6a6a6;
        }

        .locale-changer {
            display: flex;
            align-items: center;
        }

        .mdi {
            font-size: 50px;
            display: flex;
            margin-right: 15px;
        }
    }

    .user-system img {
        cursor: pointer;
        max-width: 40px;
        max-height: 40px;
        border-radius: 10px;
        margin-top: auto;
        margin-bottom: auto;
    }
}
</style>
